import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
    DashboardReview,
    DashboardReviewAcknowledged,
    DashboardReviewMetaData,
} from 'Interfaces/Review/DashboardReview';
import { ReviewLocation, reviewInitialState } from './state';

const removeReview = (reviews: DashboardReview[], reviewIndex: ReviewLocation): DashboardReview[] => {
    return reviews.filter((review) => {
        if (review.reviewId === reviewIndex.reviewId && review.reviewerUUID === reviewIndex.reviewerUUID) {
            return false;
        }
        return true;
    });
};

const setAcknowledged = (reviews: DashboardReview[], updatedReview: DashboardReviewAcknowledged): DashboardReview[] => {
    const reviewsData = [...reviews];
    const index = reviews.findIndex((r) => r.reviewId === updatedReview.reviewId);
    if (index > -1) {
        const review = { ...reviewsData[index], isAcknowledged: updatedReview.isAcknowledged };
        reviewsData.splice(index, 1, review);
    }
    return reviewsData;
};

const reviewSlice = createSlice({
    name: 'review',
    initialState: reviewInitialState,
    reducers: {
        SAVE_UPDATED_REVIEWS_BACKUP: (state, action: PayloadAction<DashboardReview[]>) => {
            const reviews = action.payload;
            return {
                ...state,
                updatedReviewsBackup: reviews,
            };
        },
        SAVE_UPDATED_REVIEWS_DATA: (state, action: PayloadAction<DashboardReview[]>) => {
            const updatedReviews = action.payload;
            return {
                ...state,
                updatedReviews,
            };
        },
        SAVE_DASHBOARD_REVIEWS_METADATA: (state, action: PayloadAction<DashboardReviewMetaData>) => {
            const metadata = action.payload;
            return {
                ...state,
                dashboardReviewsMetadata: metadata,
            };
        },
        APPLY_UPDATED_REVIEWS_BACKUP: (state) => {
            return {
                ...state,
                updatedReviews: state.updatedReviewsBackup,
            };
        },
        REMOVE_REVIEW: (state, action: PayloadAction<ReviewLocation>) => {
            const reviewThatAreAboutToBeRemoved = action.payload;

            return {
                ...state,
                updatedReviews: removeReview(state.updatedReviews, reviewThatAreAboutToBeRemoved),
                updatedReviewsBackup: removeReview(state.updatedReviewsBackup, reviewThatAreAboutToBeRemoved),
            };
        },
        SET_REVIEW_ACKNOWLEDGED: (state, action: PayloadAction<DashboardReviewAcknowledged>) => {
            const updatedData = action.payload;
            return {
                ...state,
                updatedReviews: setAcknowledged(state.updatedReviews, updatedData),
                updatedReviewsBackup: setAcknowledged(state.updatedReviewsBackup, updatedData),
            };
        },
    },
});

export const { reducer: reviewReducer, actions: reviewActions } = reviewSlice;
